import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    Session,
    SessionService,
    TrainingSessionCompany,
    TrainingSessionContact,
    TrainingSessionStudent,
    RegistrationDetailService,
} from '../../../../../../../_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'registration-student',
    templateUrl: 'registration-student.component.html',
    styleUrls: [
        '../../../registration.component.scss',
        '../../../../../../_shared/label/label.component.scss',
    ],
})
export class RegistrationStudentComponent implements OnInit {
    @Input() tsCompany: TrainingSessionCompany;
    @Input() tsContact: TrainingSessionContact;
    @Input() tsCompanies: TrainingSessionCompany[];
    @Input() session: Session;
    @Input() tsStudent: any;
    @Input() tsStudents: TrainingSessionStudent[];
    @Input() newRegistration: TrainingSessionStudent;
    @Output() create: EventEmitter<TrainingSessionStudent> = new EventEmitter();

    saving = false;
    deleting = false;
    private deleteModalRef;

    constructor(
        private registrationDetailsService: RegistrationDetailService,
        private modalService: NgbModal,
        private sessionService: SessionService
    ) {}

    ngOnInit(): void {
        if (!this.tsStudent) {
            this.tsStudent = {
                firstName: '',
                lastName: '',
                email: '',
                price: this.getStudentPrice(),
                displayedPrice: this.getDisplayedStudentPrice(),
                selected: false,
                editingMode: 'addOrEdit',
            };
        }
    }

    getConvocationClass(student): string {
        if (student.mailSent) {
            return 'btn-two-icons-checked';
        }
        return 'btn-two-icons';
    }

    getConventionClass(student): string {
        if (student.conventionSent) {
            return 'btn-two-icons-checked';
        }
        return 'btn-two-icons';
    }

    toggleRegistrationStudent(): void {
        this.registrationDetailsService.updateRegistrationSelection(
            this.tsCompanies
        );
    }

    studentEdition() {
        this.tsStudent.editingMode = 'addOrEdit';
    }

    getNewStudent(student) {
        if (student !== null) {
            this.saveRegistrationStudent(student);
        } else {
            this.create.emit(null);
        }
    }

    saveRegistrationStudent(student) {
        this.saving = true;
        const studentToSave = this.buildRegistrationStudent(student);
        const displayNewStudent = (student) => {
            student.editingMode = 'noEdition';
            this.create.emit(student);
            if (!student.id) {
                this.tsStudent = Object.assign({}, student);
                this.tsStudent.displayedPrice = this.getDisplayedStudentPrice();
            }
        };

        if (!student.id) {
            this.sessionService
                .addStudentToCompanySession(studentToSave, this.session.id)
                .subscribe(
                    (registration) => {
                        student.registrationDetailId = registration.id;
                        student.id = registration.student.id;
                        displayNewStudent(student);
                    },
                    null,
                    () => {
                        this.saving = false;
                    }
                );
        } else {
            this.sessionService
                .updateStudentToCompanySession(studentToSave, this.session.id)
                .subscribe(
                    () => {
                        displayNewStudent(student);
                        student.editingMode = '';
                    },
                    null,
                    () => {
                        this.saving = false;
                    }
                );
        }
    }

    buildRegistrationStudent(student) {
        let studentPrice = 0;
        if (this.tsCompany.billingMode === 'BYSTUDENT') {
            studentPrice = student.price;
        }

        return {
            id: student.id,
            price: studentPrice,
            firstName: student.firstName,
            lastName: student.lastName,
            email: student.email.toLowerCase(),
            contactId: this.tsContact.id,
            title: 'MRS',
            companyId: this.tsCompany.companyId,
            deleted: false,
            registrationDetailId: student.registrationDetailId,
            registrationId: this.getRegistrationId(),
        };
    }

    getRegistrationId() {
        if (this.newRegistration !== undefined) {
            return this.newRegistration.id;
        } else {
            return this.tsCompany.registrationId;
        }
    }

    getStudentPrice() {
        let price = 0;

        if (this.tsCompany.billingMode === 'BYSTUDENT') {
            price = this.tsCompany.price;
        } else {
            price =
                this.tsCompany.price /
                this.tsCompany.contacts.reduce(
                    (total, contact) => total + contact.students.length,
                    0
                );
        }
        return price;
    }

    getDisplayedStudentPrice(): string {
        return this.registrationDetailsService.getPrice(
            this.getStudentPrice(),
            this.tsCompany.priceCurrency
        );
    }

    deleteRegistrationDetail(student) {
        this.deleting = true;

        let studentIndex = this.tsStudents.indexOf(student, 0);
        let contactIndex = this.tsCompany.contacts.indexOf(this.tsContact, 0);

        this.registrationDetailsService
            .delete(student.registrationDetailId)
            .subscribe(
                () => {
                    if (studentIndex > -1) {
                        this.tsStudents.splice(studentIndex, 1);
                    }
                    if (
                        this.tsCompany.contacts[contactIndex].students
                            .length === 0
                    ) {
                        this.tsCompany.contacts.splice(contactIndex, 1);
                    }
                    this.closeDeleteModal();
                },
                null,
                () => {
                    this.deleting = false;
                }
            );
    }

    closeDeleteModal() {
        this.deleteModalRef.close();
    }

    openDeleteModal(deleteModal) {
        event.stopPropagation();
        this.deleteModalRef = this.modalService.open(deleteModal);
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/registration-contact/registration-student/registration-student.component.ts